import { useMemo, useState } from "react"
import { useFormikContext, getIn } from "formik"
import * as Yup from 'yup'
import { 
  FormikFileUpload,
  ApplicationFileDownload,
  FormikNotesArea
} from "../../../../../components/widgets"
    
export const initDLMSubmitSignedROIValues = {
  siteROIModels: [],
  note: '',
  noteAttachments: [],    
}

export const DLMSubmitSignedROISchema = Yup.object({
  siteROIModels: Yup.array().of(
  Yup.object().shape({
    siteID: Yup.number().integer(),
    projectName: Yup.string().trim(),
    clientRefNo: Yup.string().trim(),
    roiModels: Yup.array().of(
      Yup.object().shape({
        roiId: Yup.number().integer().label('ROI Id'),
        roiAttachmentId: Yup.number().integer().integer().moreThan(0,'Signed ROI required').required().label('Signed ROI Attachment'),
        roiAttachmentIdAttachmentName: Yup.string().trim(),
      })
    )
  })
  ),
  note: Yup.string().trim().label('Note'),  
  noteAttachments: Yup.array(),    
})


const DLMSubmitSignedROIForm = () => {


  const [siteIndex] = useState(0);
  const { values, validateField } = useFormikContext();

  const siteROIModels = getIn(values, 'siteROIModels');

  const rois = useMemo(() => {
    if (! (siteROIModels && siteROIModels.length > 0)) {
      return [];
    }
    
    if (! (siteROIModels && siteIndex < siteROIModels.length && siteROIModels[siteIndex]?.roiModels)) {
      return [];
    }
    
    const rois = siteROIModels[siteIndex].roiModels;
    
    return rois;
  }, [siteROIModels, siteIndex]);


  return (
  <>
  <h4>Upload Signed ROI:</h4>
  <div className='text-muted fs-7'>Please dowload and endorse before submitting.</div>                           
  <div className='separator border-gray-200 mb-2'></div>        
  <div className="mh-250px overflow-auto pe-4">        {
    rois.map((roiModel: any, idx: number) => (
    <div key={`setROIrow_${idx}`} className="row mb-4">
      <div className="col-5">        
        { roiModel.draftROIFile && 
        <>
        <div className="text-muted fs-7">Draft ROI</div>
        <ApplicationFileDownload file={roiModel.draftROIFile} />
        </>
        } 
      </div>              
      <FormikFileUpload 
        size="7" 
        label={`[${roiModel.cbRef}] ${roiModel.projectName}`} 
        name={`siteROIModels.${siteIndex}.roiModels.${idx}.roiAttachmentId`} 
        acceptFiles="ApplicantFileFormats" 
        required={true}   
        subTitle="Upload signed ROI here."   
        onUpdateFunc={ () => {
            validateField('siteROIModels');
        }}                   
      />
    </div>
    ))        
    }
  </div>            

  <FormikNotesArea />
  </>
  )
}

export { DLMSubmitSignedROIForm }